/**
 * Table answers are JSON, but V1 repeated contact sections join each contact's answer with `|`.
 * JSON only allows `|` inside strings, and `\u007c` is the standard JSON escape for it, so this
 * keeps the value valid JSON that `JSON.parse` decodes unchanged while guaranteeing it never
 * contains a literal pipe that would split it.
 */
export function escapeTableValuePipes(value: string): string {
    return value.replaceAll('|', '\\u007c');
}

export function serializeIntakeTableRows(rows: unknown[]): string {
    return escapeTableValuePipes(JSON.stringify(rows));
}

/**
 * One JSON value per contact for a table answer from a V1 repeated contact section. Answers saved
 * before pipes were escaped can hold literal pipes inside cell text, so a value that already parses
 * as JSON is never split.
 */
export function splitPipeJoinedTableValue(value: string): string[] {
    try {
        JSON.parse(value);
        return [value];
    } catch {
        return value.split('|');
    }
}
